import {Repository, createRepository} from '@/repositories/Base/Repository'

class TimeRepository extends Repository {
    endpoint = 'tuevs/times'

    put(id, params) {
        return this.$axios.put(`${this.endpoint}/${id}/update`, params)
    }

    fetch(id) {
        return this.$axios.get(`${this.endpoint}/${id}/show`)
    }
}

export default new TimeRepository()

export const create = createRepository(TimeRepository)
